
import { mapState, mapGetters } from "vuex";
import { dashesToCamelCase } from "~/common/helpers";
import recentlyViewed from "~/components/profiles/recently-viewed.vue";
import { getCroppedImageUrl } from "~/common/helpers";
import { mdiMessageDraw } from "@mdi/js";
import ApplyedFilters from "~/components/v2/common/header/desktop/hd-applyed-filters.vue";

export default {
  components: {
    recentlyViewed,
    ApplyedFilters,
  },

  props: {
    catalogTitle: {
      type: String,
      default: "Catalog",
    },
  },

  data() {
    return {
      mdiMessageDraw,
    };
  },

  fetch() {
    this.setSelectedCategoryFromUrl();
  },

  head() {
    return {
      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(this.jsonld),
        },
      ],

      __dangerouslyDisableSanitizers: ["script"],
    };
  },

  computed: {
    ...mapState(["profiles", "menus"]),

    ...mapGetters({
      profilesAllShort: "profiles/getProfilesAllShort",
      discreetMode: "getDiscreetStatus",
      statusesSlider: "sliders/statusesSlider",
      reviewsSlider: "sliders/getLastReviews",
      viewedProfiles: "profiles/getViewedProfiles",
      filters: "profiles/getFilters",
      catalogMode: "catalog/getCatalogMode",
      catalogMinCol: "catalog/getMinCol",
      showLegend: "global/getShowLegend",
    }),

    showText() {
      return this.showLegend;
    },

    displayGender() {
      let gender = this.filters.gender;
      if (!gender) return "";
      const result = gender
        .split(",")
        .map(
          (word) => word.trim().charAt(0).toUpperCase() + word.trim().slice(1)
        )
        .join(", ");
      return result;
    },

    isFullMobile() {
      // return this.catalogMinCol == 2 && this.catalogMode == "grid";
      return false;
    },

    jsonld() {
      return {
        "@context": "http://schema.org",
        "@type": "ItemList",
        name: this.catalogTitle,
        url: `${this.$config.baseUrlApp}${this.$route.path}`,
        itemListElement: this.profilesAllShort.map((profile, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `${this.$config.baseUrlApp}/profile/${profile.slug}`,
          name: profile.name,
          image: profile.mainPhoto,
          description: profile.description,
        })),
      };
    },
  },

  watch: {
    profilesAllShort: {
      handler() {
        this.$emit("profiles-count-changed", this.profilesAllShort?.length);
      },
      immediate: true,
    },
  },

  mounted() {
    console.log("mounted");
    this.$root.$on("scroll-to-top", () => {
      console.log("scroll-to-top");
      this.scrollToTitle();
    });
  },

  methods: {
    changeShowLegend() {
      this.$store.commit("global/setShowLegend", !this.showLegend);
    },

    catalogFilterModifier() {
      this.$store.commit("catalog/setCatalogFilter");
    },

    setSelectedCategoryFromUrl() {
      // TODO: WTF is going on wrong here?
      console.log("setSelectedCategoryFromUrl");
      const categoryId = dashesToCamelCase(this.$route.params.category);
      console.log("categoryId", categoryId);
      if (!categoryId) return;
      this.$store.commit("menus/changeActiveFilterById", categoryId);
      const selectedFilter =
        this.$store.getters["menus/getStatusNavFilterById"](categoryId);
      this.$store.commit("profiles/changePageFilter", selectedFilter);
    },

    getCroppedImageUrl(fullImageUrl, size, discreetMode) {
      return getCroppedImageUrl(fullImageUrl, size, discreetMode);
    },

    scrollToTitle() {
      if (!this.$refs.title) return;
      const headerEl = document.querySelector(".header-v2");
      const headerHeight = headerEl ? headerEl.offsetHeight + 16 : 16;
      const titleEl = this.$refs.title;
      const titleTop = titleEl ? titleEl.getBoundingClientRect().top : 0;
      const scrollY = window.scrollY;
      const offset = titleTop + scrollY - headerHeight;
      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    },
  },
};
